(() => {
  const initFaqTabs = (section = document) => {
    section.querySelectorAll('[data-lndu-faq-tabs]').forEach((root) => {
      const triggers = Array.from(root.querySelectorAll('[data-faq-category-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-faq-category-panel]'));

      const activateCategory = (categoryId) => {
        triggers.forEach((trigger) => {
          const isActive = trigger.dataset.faqCategoryTrigger === categoryId;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.faqCategoryPanel === categoryId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;

          if (isActive) {
            const items = Array.from(panel.querySelectorAll('.lndu-home-faq-tabs__item'));
            items.forEach((item, index) => {
              setItemOpen(item, index === 0 && window.matchMedia('(min-width: 750px)').matches);
            });
          }
        });
      };

      const setItemOpen = (item, shouldOpen) => {
        const button = item.querySelector('.lndu-home-faq-tabs__question');
        const answer = item.querySelector('.lndu-home-faq-tabs__answer');

        item.classList.toggle('is-open', shouldOpen);
        if (button) {
          button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        }
        if (answer) {
          answer.hidden = !shouldOpen;
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          activateCategory(trigger.dataset.faqCategoryTrigger);
        });
      });

      root.querySelectorAll('.lndu-home-faq-tabs__question').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('.lndu-home-faq-tabs__item');
          const panel = button.closest('[data-faq-category-panel]');
          if (!item || !panel) return;

          const shouldOpen = !item.classList.contains('is-open');
          panel.querySelectorAll('.lndu-home-faq-tabs__item').forEach((panelItem) => {
            setItemOpen(panelItem, false);
          });
          setItemOpen(item, shouldOpen);
        });
      });

      const activeTrigger = triggers.find((trigger) => trigger.classList.contains('is-active')) || triggers[0];
      if (activeTrigger) {
        activateCategory(activeTrigger.dataset.faqCategoryTrigger);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFaqTabs());
  document.addEventListener('shopify:section:load', (event) => initFaqTabs(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const trigger = event.target && event.target.matches('[data-faq-category-trigger]')
      ? event.target
      : event.target && event.target.querySelector('[data-faq-category-trigger]');
    if (!trigger) return;

    const root = trigger.closest('[data-lndu-faq-tabs]');
    if (!root) return;

    const categoryId = trigger.dataset.faqCategoryTrigger;
    root.querySelectorAll('[data-faq-category-trigger]').forEach((categoryTrigger) => {
      const isActive = categoryTrigger.dataset.faqCategoryTrigger === categoryId;
      categoryTrigger.classList.toggle('is-active', isActive);
      categoryTrigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-faq-category-panel]').forEach((panel) => {
      const isActive = panel.dataset.faqCategoryPanel === categoryId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  });
})();
